module.exports = __webpack_public_path__ + "img/drop_down_arrow_black.a4e55b00.svg";